<template>
  <transition name="apple-ui-modal">
    <div v-if="open" class="apple-ui-modal-backdrop" @click.self="close">
      <section ref="dialog" class="apple-ui-modal" role="dialog" aria-modal="true" :aria-labelledby="titleId" @keydown="onKeydown">
        <header class="apple-ui-modal-header">
          <h2 :id="titleId">{{ title }}</h2>
          <button type="button" class="apple-ui-modal-close" aria-label="关闭" @click="close">×</button>
        </header>
        <div class="apple-ui-modal-body"><slot /></div>
        <footer v-if="$slots.footer" class="apple-ui-modal-footer"><slot name="footer" /></footer>
      </section>
    </div>
  </transition>
</template>

<script>
let nextId = 0;
export default {
  name: 'AppleModal',
  props: { open: Boolean, title: { type: String, required: true }, initialFocus: { type: String, default: '' } },
  data() { return { titleId: `apple-modal-title-${++nextId}`, returnFocus: null }; },
  watch: {
    open(value) {
      if (value) {
        this.returnFocus = document.activeElement;
        this.$nextTick(() => (this.initialFocus && this.$refs.dialog?.querySelector(this.initialFocus) || this.$refs.dialog?.querySelector('button,input,select,textarea,a[href],[tabindex="0"]'))?.focus({ preventScroll: true }));
      }
    },
  },
  methods: {
    focusable() { return Array.from(this.$refs.dialog?.querySelectorAll('button,input,select,textarea,a[href],[tabindex="0"]') || []).filter(el => !el.disabled && el.getAttribute('aria-hidden') !== 'true' && el.getClientRects().length); },
    onKeydown(event) {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.close(); return; }
      if (event.key !== 'Tab') return;
      const items = this.focusable(); if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    },
    close() {
      this.$emit('close');
      this.$nextTick(() => { if (this.returnFocus?.isConnected && typeof this.returnFocus.focus === 'function') this.returnFocus.focus({ preventScroll: true }); });
    },
  },
};
</script>

<style scoped>
.apple-ui-modal-backdrop { position:fixed; z-index:500; inset:0; display:grid; place-items:center; padding:24px; background:rgb(0 0 0 / 24%); }
.apple-ui-modal { display:flex; flex-direction:column; width:min(560px,100%); max-height:min(720px,100%); overflow:hidden; border:1px solid var(--apple-ui-border,var(--apple-border)); border-radius:14px; background:color-mix(in srgb,var(--color-body-bg) 92%,transparent); color:var(--apple-ui-text,var(--color-text)); box-shadow:0 24px 80px rgb(0 0 0 / 24%); backdrop-filter:blur(22px) saturate(1.12); -webkit-backdrop-filter:blur(22px) saturate(1.12); }
.apple-ui-modal-header { display:flex; align-items:center; gap:12px; min-height:52px; padding:0 16px; border-bottom:1px solid var(--apple-ui-border,var(--apple-border)); }
.apple-ui-modal-header h2 { min-width:0; margin:0; font-size:17px; line-height:1.3; overflow-wrap:anywhere; }
.apple-ui-modal-close { flex:none; width:30px; height:30px; margin-left:auto; border:0; border-radius:50%; background:color-mix(in srgb,var(--apple-ui-text,var(--color-text)) 8%,transparent); color:inherit; font:inherit; font-size:22px; line-height:1; cursor:pointer; }
.apple-ui-modal-close:focus-visible { outline:none; box-shadow:inset 0 0 0 2px var(--apple-ui-accent,var(--color-primary)); }
.apple-ui-modal-body { min-height:0; overflow:auto; padding:16px; }
.apple-ui-modal-footer { display:flex; justify-content:flex-end; gap:8px; padding:12px 16px; border-top:1px solid var(--apple-ui-border,var(--apple-border)); }
.apple-ui-modal-enter-active,.apple-ui-modal-leave-active { transition:opacity .18s ease; }.apple-ui-modal-enter,.apple-ui-modal-leave-to { opacity:0; }
@media(prefers-reduced-motion:reduce) { .apple-ui-modal-enter-active,.apple-ui-modal-leave-active { transition:none; } }
</style>
